import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return <header className="bg-[#1a3a6c] text-white shadow-md" data-id="element-89">
      <div className="container mx-auto px-4 py-4" data-id="element-90">
        <div className="flex justify-between items-center" data-id="element-91">
          <Link to="/" className="flex items-center" data-id="element-92">
            <div className="text-2xl font-bold text-white flex items-center" data-id="element-93">
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="mr-2" data-id="element-94">
                <circle cx="20" cy="20" r="18" stroke="#f97316" strokeWidth="4" data-id="element-95" />
                <path d="M12 20C12 15.5817 15.5817 12 20 12C24.4183 12 28 15.5817 28 20" stroke="white" strokeWidth="3" strokeLinecap="round" data-id="element-96" />
                <path d="M20 20L25 25" stroke="white" strokeWidth="3" strokeLinecap="round" data-id="element-97" />
              </svg>
              Opticore
            </div>
          </Link>
          {/* Mobile menu button */}
          <div className="md:hidden" data-id="element-98">
            <button onClick={toggleMenu} className="text-white focus:outline-none" data-id="element-99">
              {isMenuOpen ? <XIcon size={24} data-id="element-100" /> : <MenuIcon size={24} data-id="element-101" />}
            </button>
          </div>
          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-6 text-sm" data-id="element-102">
            <Link to="/" className="hover:text-[#f97316] transition-colors" data-id="element-103">
              Home
            </Link>
            <Link to="/service-coverage" className="hover:text-[#f97316] transition-colors" data-id="element-104">
              Service Coverage
            </Link>
            <Link to="/about-us" className="hover:text-[#f97316] transition-colors" data-id="element-105">
              About Us
            </Link>
            <Link to="/contact-us" className="hover:text-[#f97316] transition-colors" data-id="element-106">
              Contact Us
            </Link>
            <Link to="/faq" className="hover:text-[#f97316] transition-colors" data-id="element-107">
              FAQs
            </Link>
            <div className="group relative" data-id="element-108">
              <button className="hover:text-[#f97316] transition-colors flex items-center" data-id="element-109">
                Policies
                <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-110">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" data-id="element-111"></path>
                </svg>
              </button>
              <div className="absolute left-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-10 hidden group-hover:block" data-id="element-112">
                <Link to="/cancellation-policy" className="block px-4 py-2 text-gray-800 hover:bg-gray-100" data-id="element-113">
                  Cancellation Policy
                </Link>
                <Link to="/refund-policy" className="block px-4 py-2 text-gray-800 hover:bg-gray-100" data-id="element-114">
                  Refund Policy
                </Link>
                <Link to="/privacy-policy" className="block px-4 py-2 text-gray-800 hover:bg-gray-100" data-id="element-115">
                  Privacy & Cookie Policy
                </Link>
                <Link to="/terms-conditions" className="block px-4 py-2 text-gray-800 hover:bg-gray-100" data-id="element-116">
                  Terms & Conditions
                </Link>
              </div>
            </div>
          </nav>
        </div>
        {/* Mobile Navigation */}
        {isMenuOpen && <div className="md:hidden mt-4 pb-4" data-id="element-117">
            <div className="flex flex-col space-y-3" data-id="element-118">
              <Link to="/" className="hover:text-[#f97316]" onClick={toggleMenu} data-id="element-119">
                Home
              </Link>
              <Link to="/service-coverage" className="hover:text-[#f97316]" onClick={toggleMenu} data-id="element-120">
                Service Coverage
              </Link>
              <Link to="/about-us" className="hover:text-[#f97316]" onClick={toggleMenu} data-id="element-121">
                About Us
              </Link>
              <Link to="/contact-us" className="hover:text-[#f97316]" onClick={toggleMenu} data-id="element-122">
                Contact Us
              </Link>
              <Link to="/faq" className="hover:text-[#f97316]" onClick={toggleMenu} data-id="element-123">
                FAQs
              </Link>
              <div className="pt-2 border-t border-[#3b82f6]" data-id="element-124">
                <p className="text-sm font-semibold mb-2" data-id="element-125">Policies:</p>
                <div className="flex flex-col space-y-2 pl-2" data-id="element-126">
                  <Link to="/cancellation-policy" className="hover:text-[#f97316] text-sm" onClick={toggleMenu} data-id="element-127">
                    Cancellation Policy
                  </Link>
                  <Link to="/refund-policy" className="hover:text-[#f97316] text-sm" onClick={toggleMenu} data-id="element-128">
                    Refund Policy
                  </Link>
                  <Link to="/privacy-policy" className="hover:text-[#f97316] text-sm" onClick={toggleMenu} data-id="element-129">
                    Privacy & Cookie Policy
                  </Link>
                  <Link to="/terms-conditions" className="hover:text-[#f97316] text-sm" onClick={toggleMenu} data-id="element-130">
                    Terms & Conditions
                  </Link>
                </div>
              </div>
            </div>
          </div>}
      </div>
    </header>;
};
export default Header;